import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";

interface ImageWithPreviewProps {
  src: string;
  alt: string;
}
export function ImageWithPreview({ src, alt }: ImageWithPreviewProps) {
  return (
    <Dialog>
      <DialogTrigger className="flex h-36 items-center justify-center overflow-hidden">
        <img src={src} alt={alt} />
      </DialogTrigger>
      <DialogContent>
        <img src={src} alt={alt} />
      </DialogContent>
    </Dialog>
  );
}
